import { render, staticRenderFns } from "./up-down-cost.vue?vue&type=template&id=1131cef7&scoped=true&"
import script from "./up-down-cost.vue?vue&type=script&lang=js&"
export * from "./up-down-cost.vue?vue&type=script&lang=js&"
import style0 from "./up-down-cost.vue?vue&type=style&index=0&id=1131cef7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1131cef7",
  null
  
)

export default component.exports